import "../../config/globalConstants.js";
import { showError as e, showSuccess as t } from "../../services/alert/alert.js";
import "../../services/index.js";
import { copyToClipboard as n } from "../../utils/copyToClipboard.js";
import { TestAnchors as r } from "./test.js";
import { jsx as i } from "react/jsx-runtime";
import { Button as a } from "@jetbrains/ring-ui-built/components/button/button";
import o from "@jetbrains/ring-ui-built/components/tooltip/tooltip";
import s from "@jetbrains/icons/copy.js";
//#region src/components/CopyButton/CopyButton.tsx
var c = 2e3, l = "Copied", u = "Couldn't copy. Please try again.", d = (d) => {
	let { textToCopy: f, showTooltip: p = !0, tooltip: m = {}, children: h, iconClassName: g, className: _, containerClassName: v, onCopy: y, alertSuccessText: b = l, ...x } = d, S = async (t) => {
		if (t) try {
			return await n(t), y?.(), !0;
		} catch {
			return e(u), !1;
		}
		else return e(u), !1;
	}, C = async (e) => {
		e.stopPropagation(), await S(f) && t(b, c);
	}, w = async (e) => {
		(e.key === "Enter" || e.key === " ") && (e.preventDefault(), await C(e));
	};
	return /* @__PURE__ */ i(o, {
		...m,
		delay: 800,
		title: p ? m?.title ?? "Copy" : void 0,
		className: v,
		children: /* @__PURE__ */ i(a, {
			"aria-label": "Copy button",
			"data-test": r.copyButton,
			onClick: C,
			onKeyDown: w,
			inline: !0,
			className: _,
			icon: s,
			iconClassName: g,
			...x,
			children: h
		})
	});
};
//#endregion
export { d as CopyButton };
